import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Timezone} from 'src/app/models';
import {SchedulesService} from 'src/app/services';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';

@Component({
    selector: 'app-timezone',
    templateUrl: './timezone.component.html',
    styleUrls: ['./timezone.component.scss']
})
export class TimezoneComponent implements OnInit {
    timezones: Timezone[] = [];
    formattedTimezones: string[] = [];
    autocompleteTimezones: string[] = [];
    selected: Timezone;
    @Input() defaultId = Intl.DateTimeFormat().resolvedOptions().timeZone;
    @Input() disabled = false;
    @Output() selectedEvent = new EventEmitter<Timezone>();

    constructor(private schedulesService: SchedulesService) {
    }

    ngOnInit(): void {
        this.schedulesService.getAllTimezones().subscribe((timezones: Timezone[]) => {
            this.timezones = timezones;
            this.formattedTimezones = this.timezones.map(t => this.formatTimezone(t));
            // this.getAutocompleteTimezones(''); // start by filtering by none to show all timezone
            this.selected = this.timezones.find(tz => tz.id === this.defaultId);
            this.selectedEvent.emit(this.selected);
        });
    }

    onTimezoneChange($event: any) {
        if (typeof $event === 'string') { // if is not input event
            this.getAutocompleteTimezones($event);
        }
    }

    onTimezoneSelected($event: MatAutocompleteSelectedEvent) {
        this.selected = this.timezones.find(t => $event.option.value === this.formatTimezone(t));
        this.selectedEvent.emit(this.selected);
    }

    getAutocompleteTimezones(search: string) {
        this.autocompleteTimezones = this.formattedTimezones.filter(f => f.toLowerCase().includes(search.toLowerCase()));
    }

    formatTimezone(timezone: Timezone): string {
        return `(GMT${timezone.offset}) ${timezone.id}`;
    }
}
